'use client';

import type React from 'react';
import { createContext, useContext, useMemo } from 'react';

/** layout から受け取る表示用のフラグ。 */
type SelfView = { adsOff: boolean; gaOff: boolean };

const SelfViewContext = createContext<SelfView>({ adsOff: false, gaOff: false });

export function SelfViewProvider({
  adsOff,
  gaOff,
  children,
}: SelfView & { children: React.ReactNode }) {
  const value = useMemo(() => ({ adsOff, gaOff }), [adsOff, gaOff]);
  return <SelfViewContext value={value}>{children}</SelfViewContext>;
}

export function useSelfView(): SelfView {
  return useContext(SelfViewContext);
}
